import { memo } from 'react';
import { IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import type { IconButtonProps } from '@mui/material';

const useStyles = makeStyles({ name: 'ArrowButton' })((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    transition: theme.transitions.create('opacity'),
    opacity: 0,

    '&:hover': {
      opacity: 1,
    },

    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  leftButton: {
    left: theme.spacing(1),
    right: 'auto',
  },
  rightButton: {
    left: 'auto',
    right: theme.spacing(1),
  },
  visible: {
    opacity: 1,
  },
}));

interface ArrowButtonProps {
  readonly direction: 'left' | 'right';
  readonly visibility?: 'visible' | 'hover';
  readonly onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const ArrowButton = memo<ArrowButtonProps & IconButtonProps>(({
  direction, onClick, visibility = 'hover', ...restProps
}) => {
  const { classes, cx } = useStyles();

  const Icon = direction === 'left' ? ChevronLeftIcon : ChevronRightIcon;

  return (
    <IconButton
      color="paper"
      size="small"
      onClick={onClick}
      className={cx(classes.root, direction === 'left' ? classes.leftButton : classes.rightButton, visibility === 'visible' && classes.visible)}
      component="div"
      {...restProps}
    >
      <Icon />
    </IconButton>
  );
});
